import { useQuery } from 'react-query';
import useContentfulLocale from 'components/useContentfulLocale';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { getListsFn } from '../services/getList';

/**
 * Centralized hook for fetching lists data
 * This hook can be used across components to share data and reduce duplicate API calls
 */
export const useListsData = (listsIds, options = {}) => {
  const ctfLocaleFilter = useContentfulLocale();
  const clientDetails = useSelector(state => state.main.clientDetails);

  const clientExcludedTopicIds = _get(
    clientDetails,
    'excludeTopicCollection.items',
    [],
  ).map(s => s.sys.id);

  const {
    isResources = false,
    queryKey = 'shared-lists-data',
    staleTime = 5 * 60 * 1000, // 5 minutes
    cacheTime = 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus = false,
  } = options;

  return useQuery(
    !!listsIds?.length && [
      queryKey,
      {
        listsIds,
        clientExcludedTopicIds,
        localeFilters: ctfLocaleFilter,
        isResources,
      },
    ],
    getListsFn,
    {
      staleTime,
      cacheTime,
      refetchOnWindowFocus,
    },
  );
};
